module.exports = __webpack_public_path__ + "static/media/logo.6b18cdab.svg";